import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ValidationService } from '@services/ui/validation.service';
import { ControlValueAccessorBase } from '@shared/bases/control-value-accessor.base';
import { TooltipComponent } from '@shared/components/tooltip/tooltip.component';
import { SharedModule } from '@shared/modules/shared.module';
@Component({
	selector: 'app-password',
	imports: [SharedModule, TooltipComponent],
	templateUrl: './password.component.html',
	styleUrl: './password.component.scss',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => PasswordComponent),
			multi: true,
		},
	],
})
export class PasswordComponent extends ControlValueAccessorBase<string> {
	@Input() placeholder = '';
	@Input() label = '';
	@Input() helperText = '';
	@Input() size: 'small' | 'medium' | 'large' = 'large';
	@Input() disabled = false;
	@Input() error = false;
	@Input() errorMessage = '';
	@Input() autocomplete: 'current-password' | 'new-password' = 'current-password';
	@Input() showTooltip = false;
	@Input() icon = '';
	@Input() iconPosition: 'left' | 'right' = 'left';

	constructor(private validationService: ValidationService) {
		super();
	}

	tooltipHtml = '';
	ngOnInit(): void {
		this.tooltipHtml = this.validationService.getTooltipMessage('invalidPassword');
	}

	onInput(event: any): void {
		const value = event.target.value;
		this.onChange(value);
		this.onTouched();
	}
}
